import React from 'react';
import OverWindow from '../../../Elements/TabList/OverWindow';
import FraudHitEvaluatorMatchItem from '../../../Domain/FraudHitEvaluatorMatchItem';
import FigmaPopup from '../../../Elements/figmaPopup';
import PopupTypesEnum from '../../../Enums/PopupTypesEnum';
import WarningTypesEnum from '../../../Enums/WarningTypesEnum';
import TabbedPage from '../../../Elements/TabbedPage';
import BaseEvaluatorTab from './BaseEvaluatorTab';
import MatchMatrixTab from './MatchMatrixTab';

export default class ShowMatchesOverDataWindow extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      popup: null,
    };
    this.topPaneRef = React.createRef();

    FraudHitEvaluatorMatchItem.setInfo = this.setInfo.bind(this);
  }

  componentDidMount() {
    // Same stacked-grid recipe as FraudHitDetails: refit the lower Matrix grid whenever the top
    // pane's height changes (base-shopper data replacing the loading block). The height-fit is
    // idempotent, so the observer can't loop. (The global ResizeObserver wrapper in
    // Helpers/patchResizeObserver.js already defers every callback a frame, so the dispatch no
    // longer needs its own requestAnimationFrame.)
    this.topPaneObserver = new ResizeObserver(() => window.dispatchEvent(new Event('resize')));
    if (this.topPaneRef.current) this.topPaneObserver.observe(this.topPaneRef.current);
  }

  componentWillUnmount() {
    if (this.topPaneObserver) this.topPaneObserver.disconnect();
  }

  setInfo = (item) => {
    const message = constructInfoMessage();

    this.setState({
      popup: (
        <FigmaPopup
          type={PopupTypesEnum.Info}
          warningType={WarningTypesEnum.WithOneButton}
          text={message}
          okPopupFunction={() => this.setState({ popup: null })}
          closePopupFunction={() => this.setState({ popup: null })}
        />
      ),
    });

    function constructInfoMessage() {
      let message = `Base Shopper's ${item.QueryType} (${item.MatchingRecord})`;

      if (item.MatchesEmail) message += "\nSame as second Shopper's Email";
      if (item.MatchesAlipay) message += "\nSame as second Shopper's Alipay";
      if (item.MatchesPaypal) message += "\nSame as second Shopper's Paypal";
      if (item.MatchesPaynow) message += "\nSame as second Shopper's Paynow";
      if (item.MatchesWise) message += "\nSame as second Shopper's Wise";
      // if (item.MatchesPhone1) message += "\nSame as second Shopper's Phone 1";
      // if (item.MatchesPhone2) message += "\nSame as second Shopper's Phone 2";
      if (item.MatchesIban) message += "\nSame as second Shopper's IBAN";
      if (item.MatchesBankAccount) message += "nSame as second Shopper's Bank Account";
      return message;
    }
  };

  matrixTab = [
    {
      label: 'Matrix',
      id: 'matrix',
      icon: 'fa-solid fa-file-invoice',
      component: (
        <MatchMatrixTab
          fraudHitId={this.props.fraudHitId}
          fraudHitEvaluatorId={this.props.fraudHitEvaluatorId}
        />
      ),
    },
  ];

  baseTab = [
    {
      label: 'Base Shopper',
      id: 'baseevaluator',
      icon: 'fa-solid fa-file-invoice',
      component: <BaseEvaluatorTab fraudHitId={this.props.fraudHitId} />,
    },
  ];

  render() {
    return (
      <OverWindow
        clickOnCancel={this.props.clickOnCancel}
        title={`Matrix - Matches for ${this.props.fraudHitEvaluatorBaseName} (${this.props.fraudHitEvaluatorBaseEmail})`}
        closeOnClickOutside={false}
        verticalScroll={false}
        bothScroll={true}
      >
        <div className='verticalScroll showassignmentlistheight'>
          {/* .grid-fit-bounds caps the Base Shopper grid at content height; the Matrix grid
              below is left unwrapped so the height-fit runs it to the popup's bottom. */}
          <div
            className='grid-fit-bounds'
            ref={this.topPaneRef}
          >
            <TabbedPage tabs={this.baseTab} />
          </div>
          <TabbedPage tabs={this.matrixTab} />
        </div>
        {this.state.popup}
      </OverWindow>
    );
  }
}
